const style = {
  heading: {
    width: '30%',
    height: 25,
  },
  inputField: {
    width: '40%',
    height: 40,
    margin: '25px 0 50px',
  },
  pageHeading: {
    width: '15%',
    height: 20,
  },
  subHeading: {
    height: 15,
    width: '43%',
    marginTop: 30,
  },
  loading: {
    animation: 'myEffect 2000ms infinite',
    content: "''",
  },
  vHidden: {
    visibility: 'hidden',
  },
};

export default style;
